module.exports = __webpack_public_path__ + "static/media/card.5a6eb15d.svg";